// extracted by mini-css-extract-plugin
export default {"wrapper":"error-message__wrapper___HcfKr","red":"error-message__red___PtTwc"};